import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setPayerName } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const PayerName = () => {
    const dispatch = useDispatch();
    const { payerName, payerErrors } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <InputText
                    value={payerName}
                    onChange={(value) => dispatch(setPayerName(value))}
                    placeholder={trl('InvoiceAndPayerForm.PayerCreate.PayerName.placeholder')}
                    invalid={Boolean(payerErrors.fio)}
                    data-qa="fio"
                />
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerName.legend')}
            hint={trl('InvoiceAndPayerForm.PayerCreate.PayerName.hint')}
            isRequired
            error={payerErrors.fio}
        />
    );
};

export default PayerName;
